var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stat-card"},[_c('div',{staticClass:"text"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm.title))]),_c('h2',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))])])])}
var staticRenderFns = []

export { render, staticRenderFns }